<template lang="pug">
.doHEADLINE
  div {{cont.title}}
</template>
<script>
export default {
  props: ["cont"],
  created() {
    console.log(this.cont);
  }
};
</script>
<style lang="stylus" scoped>
.doHEADLINE
  width 100%
  font-size 24px
  font-family MicrosoftYaHeiUI-Bold
  font-weight bold
  color rgba(42, 46, 54, 0.8)
  line-height 25px
</style>
